import { render, staticRenderFns } from "./PageSuper.vue?vue&type=template&id=060e4b00&"
import script from "./PageSuper.vue?vue&type=script&lang=js&"
export * from "./PageSuper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports